
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, questionsActions } from "../../../_actions";
import moment from "moment";
import { CONST } from "../../../_config";
import * as XLSX from 'xlsx';
import AssessmentReport from "../../Surveylink/Component/AssessmentReport/AssessmentReport";
import AssessmentSummary from "../../Surveylink/Component/AssessmentSummary/AssessmentSummary";
import AssessmentManagerReport from "../../Surveylink/Component/AssessmentManagerReport/AssessmentManagerReport";
import AssessmentHiringReport from "../../Surveylink/Component/AssessmentHiringReport/AssessmentHiringReport";
import Footer from "../Home/Component/Footer";
// import Header from "../Home/Component/Header";4
import HeaderTransprent from "../Home/Component/HeaderTransprent";
import { MdOutlineEdit } from "react-icons/md";
import Ready from "../../../components/Ready";
import { FiUsers } from "react-icons/fi";
import { IoPeopleOutline } from "react-icons/io5";


class MyOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      activeTab: 2,
      drowdown: true,
      viewCode: true,
      modaleOpen: false,
      isEditing: false,
      formNameData: {
        "id": "",
        "name": ""
      },
      crrPackId: "",
      showReportModal: false,
      showSummaryReport: false,
      surveyLanguageCode: '',
      themeType: 2,
      crrEmpDetails: {
        "emp_id": "",
        "name": ""
      },
      selectedValue: '1',
      formUserData: {
        "name": "",
        "email": "",
        "country": "",
        "postcode": "",
        "mobile": "",
        "organisation": ""
      },
      showManagerReportModal: false,
      showHiringReport: false,
      saveSuccess: false
    };
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.ViewCode = this.ViewCode.bind(this);
    this.drowDown = this.drowDown.bind(this);
    this.ModalOpen = this.ModalOpen.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentCartCount());
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    this.props.dispatch(assessmentActions.getOrderBookList());
    window.scrollTo(0, 0);
  }

  ModalOpen = () => {
    this.setState({ modaleOpen: !this.state.modaleOpen });
  };
  ViewCode = () => {
    this.setState({ viewCode: !this.state.viewCode });
  };

  drowDown = () => {
    this.setState({ drowdown: !this.state.drowdown });
  };

  handleTabClick = (tabIndex, temp) => {
    this.setState({ activeTab: tabIndex, }, () => {
      if (tabIndex === 5) {
        let data = {
          "id": temp & temp.id ? temp.id : ""
        }
        console.log("temp-1->", temp)
        this.setState({ crrPackId: temp.id })
        this.props.dispatch(assessmentActions.userAssessmentOrders(data));
        this.props.dispatch(assessmentActions.userAssessmentResponseAnalytics(data));
      }
      else if (tabIndex === 2) {
        let { assessment } = this.props;
        let { userAssessmentUserProfileData } = assessment;
        let data = {
          "name": userAssessmentUserProfileData && userAssessmentUserProfileData.name ? userAssessmentUserProfileData.name : "",
          "email": userAssessmentUserProfileData && userAssessmentUserProfileData.email ? userAssessmentUserProfileData.email : "",
          "country": userAssessmentUserProfileData && userAssessmentUserProfileData.country ? userAssessmentUserProfileData.country : "",
          "postcode": userAssessmentUserProfileData && userAssessmentUserProfileData.postcode ? userAssessmentUserProfileData.postcode : "",
          "mobile": userAssessmentUserProfileData && userAssessmentUserProfileData.mobile ? userAssessmentUserProfileData.mobile : "",
          "organisation": userAssessmentUserProfileData && userAssessmentUserProfileData.organisation ? userAssessmentUserProfileData.organisation : ""
        }
        this.setState({ formUserData: data })
      } else {
        this.setState({ crrPackId: "" })
      }

      if (tabIndex === 2) {
        this.props.history.push(`/assessment/` + "profile-summary");
      } else if (tabIndex === 2) {
        this.props.history.push(`/assessment/` + "profile-summary");
      } else if (tabIndex === 3) {
        this.props.history.push(`/assessment/` + "my-orders");
      } else if (tabIndex === 4) {
        this.props.history.push(`/assessment/` + "assessment-code");
      } else if (tabIndex === 6) {
        this.props.history.push(`/assessment/` + "user");
      } else if (tabIndex === 7) {
        this.props.history.push(`/assessment/` + "myteam");
      }

    });
  };

  // TabClick = (tabIndex) => {
  //   this.setState({ activeTab: tabIndex });
  // };


  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.user.userAssessmentMyCartSuccess) {
      return {
        ...nextProps,
        showLogin: false,
      };
    }
    if (nextProps.user.getEmployeeStatusSucess) {
      return {
        ...nextProps,
        notFoundText: "Success!",
      };
    }
    if (nextProps.user.getEmployeeStatusFailed) {
      return {
        ...nextProps,
        notFoundText: "Employee not found!",
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem('route')
    localStorage.setItem('route', this.props.history.location.pathname)
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    this.props.history.push(`/assessment/` + field);
  };

  onEditSingleName = (element) => {
    let { formNameData } = this.state;
    formNameData = {
      "id": element.id,
      "name": element.name
    };
    this.setState({ showNameEdit: true, formNameData })
  }

  onSingleNameInput = (value, element) => {
    let { formNameData } = this.state;
    formNameData = {
      "id": element.id,
      "name": value
    };
    this.setState({ formNameData })
  }



  onSingleNameSave = () => {
    let { formNameData, crrPackId } = this.state;
    let data = {
      "id": formNameData.id,
      "name": formNameData.name,
    }
    let temp = {
      "id": crrPackId
    }
    this.props.dispatch(assessmentActions.userAssessmentOrderNameUpdate(data, temp))
    formNameData = {
      "id": "",
      "name": ""
    };
    this.setState({ showNameEdit: false })
  }

  viewReport = (ele) => {
    console.log("ele 1-->", ele);

    if (ele && ele.productId && ele.productId.code) {
      let code = ele.productId.code;

      if (code === "Top5TalentplusStrengths") {
        console.log("Top5TalentplusStrengths 1-->");
        this.handleSummaryReport(ele);
      } else if (code === "TalentPlusStrengths21") {
        console.log("TalentPlusStrengths21 1-->");
        this.handleReport(ele);
      } else if (code === "TalentplusManagerStrengths") {
        console.log("TalentplusManagerStrengths 1-->");
        this.handleManagerReport(ele);
      } else if (code === "TalentPlusHiringStrengths") {
        console.log("TalentPlusHiringStrengths 1-->");
        this.handleHiringReport(ele);
      }
    }


    let temp = {
      "emp_id": ele.emp_id,
      "name": ele.name
    }
    this.setState({ crrEmpDetails: temp })
  }



  handleReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true
    }
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showReportModal: true });
  };

  handleSummaryReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true
    }
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showSummaryReport: true });
  }

  handleManagerReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true
    }
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showManagerReportModal: true });
  }

  handleHiringReport = (ele) => {
    let data = {
      employeeId: ele.employeeId,
      isEmp: true
    }
    this.props.dispatch(questionsActions.getAssessmentReport(data));
    this.setState({ showHiringReportModal: true });
  }

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };

  closeManagerReportModal = () => {
    this.setState({ showManagerReportModal: false });
  };

  closeHiringReportModal = () => {
    this.setState({ showHiringReportModal: false });
  };

  handleLanguage = (item, langList) => {
    console.log("item------------------->", item)
    if (item.shortName === 'en') {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: 'English', surveyLanguageRTL: false });
    }
    else {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: item.name, surveyLanguageRTL: item.isRTL });
    }
  }

  handleDropdownChange(event) {
    const activeTab = event.target.value;

    if (Number(activeTab) === 2) {
      this.props.history.push(`/assessment/` + "profile-summary");

    } else if (Number(activeTab) === 2) {
      this.props.history.push(`/assessment/` + "profile-summary");

    } else if (Number(activeTab) === 3) {
      this.props.history.push(`/assessment/` + "my-orders");

    } else if (Number(activeTab) === 4) {
      this.props.history.push(`/assessment/` + "assessment-code");

    } else if (Number(activeTab) === 5) {
      this.props.history.push(`/assessment/` + "user");
    }

    this.setState({
      activeTab: Number(activeTab)
    });
  }

  handleDownloadSample = () => {
    let binary_univers = [
      {
        "name": "john"
      }
    ];

    //console.log('binary_univers: ', binary_univers)

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);

    // Create a new Workbook
    var wb = XLSX.utils.book_new()

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, 'Binary values')

    // export your excel
    XLSX.writeFile(wb, 'namefile.xlsx');
  }


  updateUserDetails = () => {
    let { formUserData } = this.state;
    setTimeout(() => {
      this.setState({ saveSuccess: true })
    }, 1000)
    let data = {
      "name": formUserData && formUserData.name ? formUserData.name : "",
      "email": formUserData && formUserData.email ? formUserData.email : "",
      "country": formUserData && formUserData.country ? formUserData.country : "",
      "postcode": formUserData && formUserData.postcode ? formUserData.postcode : "",
      "mobile": formUserData && formUserData.mobile ? formUserData.mobile : "",
      "organisation": formUserData && formUserData.organisation ? formUserData.organisation : ""
    }
    this.props.dispatch(assessmentActions.updateAssessmentUserProfile(data));
    setTimeout(() => {
      this.setState({ saveSuccess: false })
    }, 4000)
  }


  handleFormData = (value, name) => {
    let { formUserData } = this.state;
    formUserData[name] = value;
    this.setState({ formUserData })
  }


  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem('route')
      localStorage.setItem('route', `/assessment/` + field)
      this.props.history.push(`/assessment/sign-in`);
    }
  }


  toggleEditing = () => {

    if (!this.state.isEditing) {
      let { assessment } = this.props;
      let { userAssessmentUserProfileData } = assessment;
      let data = {
        "name": userAssessmentUserProfileData && userAssessmentUserProfileData.name ? userAssessmentUserProfileData.name : "",
        "email": userAssessmentUserProfileData && userAssessmentUserProfileData.email ? userAssessmentUserProfileData.email : "",
        "country": userAssessmentUserProfileData && userAssessmentUserProfileData.country ? userAssessmentUserProfileData.country : "",
        "postcode": userAssessmentUserProfileData && userAssessmentUserProfileData.postcode ? userAssessmentUserProfileData.postcode : "",
        "mobile": userAssessmentUserProfileData && userAssessmentUserProfileData.mobile ? userAssessmentUserProfileData.mobile : "",
        "organisation": userAssessmentUserProfileData && userAssessmentUserProfileData.organisation ? userAssessmentUserProfileData.organisation : ""
      }
      this.setState({ formUserData: data })
    }



    this.setState(prevState => ({
      isEditing: !prevState.isEditing
    }));
  }


  onClickMenu = (url) => {
    this.props.history.push(url)
    this.setState({ isEditing: false })
    // window.location.reload();
    // console.log('urlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurlurl', url);
  }

  handleClick = () => {
    const { history } = this.props;
    history.push('/assessment/expert'); // Replace '/expert-page' with the actual route of your expert page
  }

  render() {
    let { assessment, questions } = this.props;
    let {
      getAssessmentStatusData,
      getAssessmentReportByEmpIDData,
      getAssessmenrEmployeeDetailsData,
      getTranslateElementAllData,
      // getAssessmentCartCountData,
    } = questions;

    let { showManagerReportModal, showHiringReportModal, formUserData, crrEmpDetails, showSummaryReport, showReportModal, surveyLanguageName, surveyLanguageCode, showNameEdit, formNameData } = this.state;
    let { userAssessmentUserProfileData, getOrderBookListData, userAssessmentOrdersData, userAssessmentResponseAnalyticsData, getAssessmentPackagesShortListData, getAssessmentCartCountData } = assessment;
    // console.log("formUserData-->", formUserData);

    console.log('userAssessmentUserProfileDatauserAssessmentUserProfileDatauserAssessmentUserProfileDatauserAssessmentUserProfileData', userAssessmentUserProfileData);

    let check =
      getAssessmentStatusData && getAssessmentStatusData.check
        ? getAssessmentStatusData.check
        : 0;

    let createdAt =
      getAssessmentStatusData && getAssessmentStatusData.createdAt
        ? moment(new Date(parseInt(getAssessmentStatusData.createdAt))).utcOffset("+05:30").format("DD MMMM, YYYY")
        : "";

    const { activeTab } = this.state;


    function getDetails(orderBook, field, type, orderPack) {
      if (type === 2) {
        return field &&
          orderPack &&
          orderPack["productId"] &&
          orderPack["productId"][field]
          ? orderPack["productId"][field]
          : "";
      } else if (type === 3) {
        return field && orderPack && orderPack[field] ? orderPack[field] : "";
      } else {
        return field && orderBook && orderBook[field] ? orderBook[field] : "";
      }
    }



    function getValueRes(field) {
      return field && userAssessmentResponseAnalyticsData && userAssessmentResponseAnalyticsData[0] && userAssessmentResponseAnalyticsData[0][field] ? userAssessmentResponseAnalyticsData[0][field] : 0
    }

    let ReportDataList = [
      {
        "name": "Total",
        "value": getValueRes("total"),
        "color": '#99cc00'
      },
      {
        "name": "Clicked",
        "value": getValueRes("clicked"),
        "color": '#bf00ff'
      },
      {
        "name": "Completed",
        "value": getValueRes("completed"),
        "color": '#008080'
      },
      {
        "name": "Not Completed",
        "value": Number(getValueRes("total") - getValueRes("completed")),
        "color": '#ff9933'
      },


    ]



    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] ? getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] : ""
          }
        }
        // console.log("sentence------------>", sentence);
        // console.log("surveyLanguageCode------------>", surveyLanguageCode);
        // console.log("getTranslateElementAllData------------>", getTranslateElementAllData);

        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][surveyLanguageCode] && element["details"]["transl"][surveyLanguageCode][name] ?
          element["details"]["transl"][surveyLanguageCode][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }

    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getUserDetails(field) {
      return (field && userAssessmentUserProfileData && userAssessmentUserProfileData[field] ? userAssessmentUserProfileData[field] : "NA")
    }

    return (

      <div>
        <HeaderTransprent
          handleSignInPage={this.handleSignInPage}
          userDetails={userAssessmentUserProfileData}
          logout={this.logout}
          gotoPage={this.gotoPage}
          props2={this.props}
          cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />

        <section className="flex flex-col w-full gap-10 px-4 mx-auto mb-10 2xl:w-9/12 xl:w-11/12 xl:px-0 lg:flex-row ">
          <div className="w-full py-5 space-y-4 md:py-10">
            <div className="flex items-center pb-6 space-x-4 border-b">
              <h1 className="md:text-3xl text-2xl font-medium text-[#3D405B]">
                My Account
              </h1>{" "}
            </div>

            <div className="flex flex-col items-start w-full gap-10 py-6 xl:flex-row ">

              <div className="hidden w-full capitalize md:block lg:w-64">
                {/* <div
                  onClick={() => this.handleTabClick(1)}
                  className={
                    this.state.activeTab == 1
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-home" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
                  > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <polyline points="5 12 3 12 12 3 21 12 19 12" /> <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /> <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                  </svg>
                  <span>Profile Summary</span>
                </div> */}
                <div
                  onClick={() => this.handleTabClick(2)}
                  className={
                    this.state.activeTab == 2
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-home" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
                  > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <polyline points="5 12 3 12 12 3 21 12 19 12" /> <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /> <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                  </svg>
                  <span>Profile Summary</span>
                </div>

                <div
                  onClick={() => this.handleTabClick(3)}
                  className={
                    this.state.activeTab == 3
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-shopping-cart" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
                  > <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path> <path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path> <path d="M17 17h-11v-14h-2"></path> <path d="M6 5l14 1l-1 7h-13"></path>
                  </svg>
                  <span>my orders</span>
                </div>

                <div
                  onClick={() => this.handleTabClick(4)}
                  className={
                    ((this.state.activeTab == 4) || (this.state.activeTab == 5))
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-clipboard-text" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"
                  > <path stroke="none" d="M0 0h24v24H0z" fill="none"></path> <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path> <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path> <path d="M9 12h6"></path> <path d="M9 16h6"></path>
                  </svg>
                  <span>Assessment Code</span>
                </div>

                <div
                  onClick={() => this.handleTabClick(7)}
                  className={
                    this.state.activeTab == 7
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  {/* <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-clipboard-text" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  {" "}  <path stroke="none" d="M0 0h24v24H0z" fill="none"  ></path>{" "}  <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>{" "}  <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>{" "}  <path d="M9 12h6"></path> <path d="M9 16h6"></path></svg> */}
                  <IoPeopleOutline className="h-6 w-6" />
                  <span>My Team</span>
                </div>

                {/* <div
                  onClick={() => this.handleTabClick(6)}
                  className={
                    this.state.activeTab == 6
                      ? "bg-[#2196F3]/10 text-[#2196F3] flex space-x-4 p-4 rounded cursor-pointer"
                      : "bg-[#fff]/10 text-[#3D405B] flex space-x-4 p-4 rounded cursor-pointer"
                  }
                >
                  <FiUsers className="w-6 h-6" />
                  <span>User</span>
                </div> */}

              </div>

              <div className="block w-full md:hidden">
                <label for="countries" className="block mb-2 text-sm font-medium text-[#3D405B]">Select an option</label>
                <select id="dropdown" onChange={this.handleDropdownChange} value={activeTab} className="bg-white border border-gray-300 text-[#3D405B] text-sm rounded-lg focus:ring-[#2196F3] focus:border-[#2196F3] block w-full p-2.5">
                  <option value="2">Profile Summary</option>
                  <option value="3">My Orders</option>
                  <option value="4">Assessment Code</option>
                  <option value="6">User</option>
                </select>
              </div>

              <div className="flex-1 w-full">
                {this.state.isEditing ? (
                  <div>
                    {this.state.activeTab === 2 ? (
                      <div className="w-full flex-1 space-y-6 text-[#3D405B]">
                        <h1 className="md:text-2xl text-xl  text-[#3D405B]">Edit Profile</h1>
                        <div className="grid grid-cols-2 gap-4 ">
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500">
                              Full Name
                            </label>
                            <input
                              value={formUserData["name"]}
                              onChange={(e) => this.handleFormData(e.target.value, "name")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder="Enter Name"
                            ></input>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500">
                              Email
                            </label>
                            <input
                              disabled={true}
                              value={formUserData["email"]}
                              onChange={(e) => this.handleFormData(e.target.value, "email")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder="demo@demo.com"
                            ></input>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500 ">
                              Mobile
                            </label>
                            <input
                              value={formUserData["mobile"]}
                              onChange={(e) => this.handleFormData(e.target.value, "mobile")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder="Enter Number"
                            ></input>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500">
                              Organisation
                            </label>
                            <input
                              value={formUserData["organisation"]}
                              onChange={(e) => this.handleFormData(e.target.value, "organisation")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder=""
                            ></input>
                          </div>
                          <div className="col-span-1 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500">
                              Country
                            </label>
                            <input
                              value={formUserData["country"]}
                              onChange={(e) => this.handleFormData(e.target.value, "country")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder=""
                            ></input>
                          </div>
                          <div className="col-span-1 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block before:ml-0.5 before:text-red-500">
                              Postal Code
                            </label>
                            <input
                              value={formUserData["postcode"]}
                              onChange={(e) => this.handleFormData(e.target.value, "postcode")}
                              className="border px-4 py-2 rounded text-lg  capitalize w-full placeholder:font-medium placeholder:text-[#3D405B]/70 "
                              placeholder="Postal Code"
                            ></input>
                          </div>

                          <div className="col-span-2 pt-4 md:col-span-1" onClick={() => this.setState({ isEditing: !this.state.isEditing })}>
                            <button onClick={() => this.updateUserDetails()} className="rounded   bg-[#2196F3] text-[#fff] hover:bg-[#2196F3]/90 w-full justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center font-normal  cursor-pointer text-lg">
                              <span >Update</span>
                            </button>
                          </div>

                          <div className="col-span-2 pt-4 md:col-span-1">
                            <button onClick={this.toggleEditing} className="rounded bg-[#fff] text-[#E53935] border border-[#E53935] hover:bg-[#fff]/90 w-full justify-center duration-150 transition-all py-3 px-8 md:rounded uppercase space-x-2 flex items-center font-normal  cursor-pointer text-lg">
                              <span>Cancel</span>
                            </button>
                          </div>



                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : (

                  <div className="w-full">
                    {this.state.activeTab === 2 ? (
                      <div className="w-full flex-1 space-y-6 text-[#3D405B]">
                        {/* {this.state.saveSuccess ?
                          <div className="w-full flex space-x-4 items-center py-4 px-4 text-base tracking-wide text-[#4CAF50] rounded bg-[#4CAF5012]"> <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-check" width="30" height="30" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" >   <path stroke="none" d="M0 0h24v24H0z" fill="none" />   <circle cx="12" cy="12" r="9" />   <path d="M9 12l2 2l4 -4" /> </svg> <span>Your profile has been successfully updated!</span>
                          </div>
                          : null} */}
                        <div className="flex justify-between w-full">
                          <h1 className="md:text-2xl text-xl  text-[#3D405B]">Personal Information</h1>
                          <button onClick={this.toggleEditing} className="md:text-lg cursor-pointer text-xl text-[#2196F3] flex items-center space-x-2 bg-[#2196F3]/10 rounded px-4 pr-5 py-1.5 ">
                            <MdOutlineEdit size={22} /><span>Edit </span></button>
                        </div>
                        <div className="grid grid-cols-2 gap-6 ">
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Full Name
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("name")}</p>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Email
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("email")}</p>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Mobile
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("mobile")}</p>
                          </div>
                          <div className="col-span-2 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Organisation
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("organisation")}</p>
                          </div>
                          <div className="w-full col-span-1 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Country
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("country")}</p>
                          </div>
                          <div className="w-full col-span-1 space-y-2 ">
                            <label className="font-medium text-[#3D405B]/70 block  before:ml-0.5 before:text-red-500">
                              Postal Code
                            </label>
                            <p className="text-lg  capitalize font-medium text-[#3D405B]">{getUserDetails("postcode")}</p>
                          </div>
                        </div>

                      </div>
                    ) : null}
                  </div>
                )}
              </div>




              {this.state.activeTab === 5 ? (
                <>
                  <div className="w-full space-y-6">
                    <button
                      onClick={() => this.handleTabClick(4)}
                      className="bg-[#F9FAFB] border md:flex hidden space-x-2 items-center p-4 py-2 uppercase cursor-pointer text-[#3D405B] rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon icon-tabler icon-tabler-arrow-left"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <line x1="5" y1="12" x2="11" y2="18" />
                        <line x1="5" y1="12" x2="11" y2="6" />
                      </svg>
                      <span> Back</span>
                    </button>

                    <div className="bg-[#F9FAFB] p-6 border w-full space-y-4 rounded">
                      <h1>Assessment Survey Link:</h1>
                      <div className="border bg-white w-full flex justify-between rounded text-[#3D405B] items-center ">
                        <p className="px-4 truncate ">
                          {CONST.SURVEY_ASSESSMENT}
                        </p>
                        <div className="p-2 px-4 border-l">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-copy"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#2c3e50"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            />
                            <rect x="8" y="8" width="12" height="12" rx="2" />
                            <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-4 ">

                      {ReportDataList && ReportDataList.length > 0 ?
                        ReportDataList.map((item) =>
                          <div className="p-6 py-2 space-y-2 border rounded">
                            <p className="capitalize text-[#3D405B]/70  text-sm">
                              {item.name}
                            </p>
                            <h2 className="text-2xl text-[#3D405B]">{item.value}</h2>
                          </div>
                        ) : null}

                    </div>

                    {/* <div className="flex flex-col items-center justify-between w-full gap-4 md:flex-row">
                  <div className="lg:w-auto w-full flex justify-between border px-4 text-[#3D405B]/70 bg-white rounded text-sm items-center  overflow-hidden">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-search"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {" "}
                      <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                      ></path>{" "}
                      <circle cx="10" cy="10" r="7"></circle>{" "}
                      <line x1="21" y1="21" x2="15" y2="15"></line>
                    </svg>
                    <input
                      type="search"
                      name="search"
                      placeholder="Search by email..."
                      className="lg:w-60 w-full focus:outline-none px-2 py-2 text-[#3D405B] placeholder:font-normal font-medium "
                    />
                  </div>

                  <button
                    onClick={() => this.ModalOpen()}
                    className="cursor-pointer whitespace-nowrap bg-[#2196F3] text-white text-sm  border-[#2196F3] flex px-4 items-center space-x-2  py-2 rounded md:w-auto w-full justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="icon icon-tabler icon-tabler-cloud-upload"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1" />
                      <polyline points="9 15 12 12 15 15" />
                      <line x1="12" y1="12" x2="12" y2="21" />
                    </svg>
                    <span>Upload Team</span>
                  </button>
                </div> */}

                    <div className="overflow-x-auto whitespace-nowrap ">
                      <table className="w-full border rounded-md ">
                        <tr className="text-[#3D405B] bg-[#F9FAFB] w-[40%]">
                          <th className="p-2 px-4 font-medium text-left">
                            Name
                          </th>
                          <th className="p-2 px-4 font-medium text-left w-[40%]">
                            Assessment Code
                          </th>
                          <th className="p-2 px-4 font-medium text-center w-[20%]">
                            Reports
                          </th>
                        </tr>
                        <tbody className="divide-y ">



                          {userAssessmentOrdersData && userAssessmentOrdersData.length > 0 ?
                            userAssessmentOrdersData.map((element, index) =>
                              <>
                                <tr>
                                  <td className="p-2 px-4 text-left">
                                    <div className="flex items-center justify-between space-x-4">

                                      {element && element.name ?
                                        <span>{element.name}</span>
                                        :
                                        (showNameEdit && (formNameData["id"] === element.id) ?
                                          <>
                                            <input
                                              value={formNameData["name"]}
                                              onChange={(e) => this.onSingleNameInput(e.target.value, element)}
                                              className="border px-4 py-2 text-[#3D405B]/70 rounded-md focus:outline-none w-full "
                                              placeholder="Enter Name" ></input>
                                          </> : (
                                            <input
                                              className="border px-4 py-2 text-[#3D405B]/70 rounded-md focus:outline-none w-full "
                                              disabled={true}
                                              placeholder="No Name" ></input>
                                          ))
                                      }

                                      {showNameEdit && (formNameData["id"] === element.id) ?
                                        <span onClick={() => this.onSingleNameSave(element)} className="border  text-[#4CAF50] hover:text-[#4CAF50] p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100 ">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="icon icon-tabler icon-tabler-device-floppy "
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            />
                                            <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2" />
                                            <circle cx="12" cy="14" r="2" />
                                            <polyline points="14 4 14 8 8 8 8 4" />
                                          </svg>
                                        </span>
                                        :
                                        <span onClick={() => this.onEditSingleName(element)} className="border  text-[#3D405B]/70 hover:text-[#4CAF50] p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100 ">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="icon icon-tabler icon-tabler-device-floppy "
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            strokeWidth="1.5"
                                            stroke="currentColor"
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          >
                                            <path
                                              stroke="none"
                                              d="M0 0h24v24H0z"
                                              fill="none"
                                            ></path>
                                            <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                                            <path d="M13.5 6.5l4 4"></path>
                                          </svg>
                                        </span>
                                      }


                                    </div>
                                  </td>
                                  <td className="px-4 py-2">
                                    <div className="flex items-center justify-between space-x-4">
                                      <span className="border-[1.8px] w-full text-center rounded border-spacing-4 border-separate border-dashed p-2 px-6 bg-[#4CAF50]/10 text-[#4CAF50]  border-[#4CAF50]">
                                        {element.otpCode}
                                      </span>
                                      <span className="border  text-[#3D405B]/70 hover:text-[#4CAF50] p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100 ">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="icon icon-tabler icon-tabler-device-floppy "
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          strokeWidth="1.5"
                                          stroke="currentColor"
                                          fill="none"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        >
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <rect
                                            x="8"
                                            y="8"
                                            width="12"
                                            height="12"
                                            rx="2"
                                          />
                                          <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                                        </svg>
                                      </span>
                                    </div>
                                  </td>
                                  <td className="px-4 py-2 text-center">
                                    <button onClick={() => this.viewReport(element)} className="border  text-[#3D405B]/70 hover:text-[#4CAF50] p-2 rounded cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100 ">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon icon-tabler icon-tabler-device-floppy "
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path
                                          stroke="none"
                                          d="M0 0h24v24H0z"
                                          fill="none"
                                        />
                                        <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                                        <rect
                                          x="9"
                                          y="3"
                                          width="6"
                                          height="4"
                                          rx="2"
                                        />
                                        <line x1="9" y1="12" x2="9.01" y2="12" />
                                        <line x1="13" y1="12" x2="15" y2="12" />
                                        <line x1="9" y1="16" x2="9.01" y2="16" />
                                        <line x1="13" y1="16" x2="15" y2="16" />
                                      </svg>
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ) : null}


                        </tbody>
                      </table>
                    </div>
                  </div>
                </>
              ) : null}



            </div>
          </div>
        </section>

        <Ready />
        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />

        {
          this.state.modaleOpen ? (
            <div className="fixed top-0 right-0 z-40 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
              <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
                <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                  <h2 className="text-lg font-semibold md:text-xl test-gray-800 ">
                    Upload Team
                  </h2>
                  <div
                    onClick={() => this.ModalOpen()}
                    className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 "
                  >
                    <svg
                      className="w-6 h-6 fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                    >
                      <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z" />
                    </svg>
                  </div>
                </div>
                <div className="m-4 space-y-8 md:m-8 ">
                  <div className="p-4 space-y-2 text-sm border divide-y rounded-md text-[#3D405B]">
                    <h1 className="text-lg font-semibold text-[#3D405B] ">
                      {" "}
                      Guidelines for uploading the data
                    </h1>
                    <ol className="list-disc pl-6 space-y-1.5 py-4 text-[#3D405B] ">
                      <li className>
                        {" "}
                        Mandatory Column include emp_id and email as first column
                        &amp; second column should be in the file.
                      </li>
                      <li className="capitalize">
                        {" "}
                        Your file columns/headers should not contain any special
                        characters – this includes characters that are not numbers
                        or the English alphabet.
                      </li>
                      <li className="capitalize">
                        {" "}
                        Be careful not to include duplicates of the same row – no
                        two employees should have the same emp_id or email.
                      </li>
                      <li className="capitalize">
                        {" "}
                        Date format must be same as DD-MM-YYYY
                      </li>
                      <li className="capitalize">
                        {" "}
                        See the sample data format for reference and prepare your
                        master data accordingly without any change in mandatory
                        column names
                      </li>
                      <li className="capitalize">
                        {" "}
                        Make sure your Excel sheet is not password protected.
                      </li>
                    </ol>
                  </div>
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 gap-4 xl:grid-cols-4 md:grid-cols-2">
                      <div className="flex items-start p-2 px-4 space-x-4 rounded shadow-sm cursor-pointer 2xl:items-center bg-sky-100 md:col-span-2">
                        <span className="p-2 text-blue-500 bg-white rounded-full shadow-sm material-symbols-outlined">
                          download
                        </span>
                        <div onClick={() => this.handleDownloadSample()}>
                          <h1 className="text-sm font-medium md:text-base text-[#3D405B] ">
                            Download sample date
                          </h1>
                          <p className="text-sm text-gray-500">
                            See the sample data format for reference
                          </p>
                        </div>
                      </div>
                      <input type="file" id="file" accept=".xlsx,.csv" hidden />
                      <label
                        htmlFor="file"
                        className="rounded shadow-sm cursor-pointer bg-sky-100 md:col-span-2"
                      >
                        <div className="flex items-start p-2 px-4 space-x-4 2xl:items-center ">
                          <span className="p-2 text-blue-500 bg-white rounded-full shadow-sm material-symbols-outlined">
                            upload
                          </span>
                          <div>
                            <h1 className="text-sm font-medium md:text-base text-[#3D405B] ">
                              Upload Master Data
                            </h1>
                            <p className="text-sm text-gray-500">
                              Upload master data as per the guidelines
                            </p>
                          </div>
                        </div>
                      </label>
                    </div>
                    <div className="hidden">
                      <button className=" border border-green-500 rounded-md px-6 py-1.5 text-xs text-green-500 focus:outline-none">
                        Sample CSV
                      </button>
                      <button className="ml-22 border border-blue-500 rounded-md px-6 py-1.5 text-xs text-blue-500 focus:outline-none">
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}


        {showReportModal ? (
          <AssessmentReport
            closeReportModal={this.closeReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
          />
        ) : null}


        {showSummaryReport ? (
          <AssessmentSummary
            closeReportModal={this.closeSummaryReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
          />
        ) : null}



        {showManagerReportModal ? (
          <AssessmentManagerReport
            closeReportModal={this.closeManagerReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
          />
        ) : null}


        {showHiringReportModal ? (
          <AssessmentHiringReport
            closeReportModal={this.closeHiringReportModal}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            getAssessmenrEmployeeDetailsData={crrEmpDetails}
            createdAt={createdAt}

            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
          />
        ) : null}





      </div>
    );
  }
}

MyOrders.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(MyOrders);
